var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#55ACEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 15.0701C30.2641 15.4098 29.4733 15.6394 28.6433 15.7427C29.4905 15.214 30.1411 14.3768 30.4474 13.3793C29.642 13.8769 28.7608 14.2275 27.8419 14.4159C27.0934 13.5857 26.027 13.0668 24.8468 13.0668C22.5807 13.0668 20.7434 14.9796 20.7434 17.3388C20.7434 17.6737 20.7798 17.9997 20.8497 18.3124C17.4395 18.1342 14.4161 16.4335 12.3923 13.8488C12.0391 14.4798 11.8368 15.2137 11.8368 15.9965C11.8368 17.4787 12.5613 18.7862 13.6622 19.5524C13.0106 19.5311 12.3733 19.3479 11.8036 19.018C11.8034 19.0359 11.8034 19.0538 11.8034 19.0717C11.8034 21.1416 13.2177 22.8683 15.0948 23.2607C14.4905 23.4318 13.8567 23.4569 13.2418 23.3339C13.7639 25.0312 15.2793 26.2662 17.0748 26.3008C15.6705 27.4466 13.9012 28.1296 11.9788 28.1296C11.6476 28.1296 11.321 28.1093 11 28.0699C12.8159 29.282 14.9727 29.9892 17.2898 29.9892C24.8373 29.9892 28.9644 23.4795 28.9644 17.8342C28.9644 17.6489 28.9605 17.4647 28.9525 17.2815C29.7558 16.6769 30.4492 15.9281 31 15.0701",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d89645394809936b4a053bbed7646bd8.svg";
export { ForwardRef as ReactComponent };